{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "There are no inboxes attached to this account."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Choose the provider you want to integrate with Chatwoot."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Všetko je pripravené!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Meno schránky",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: By signing in, we only get access to your Page's messages. Your private messages can never be accessed by Chatwoot.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Meno schránky",
        "ADD_NAME": "Pridať meno pre vašu schránku",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Vybrať hodnotu",
        "CREATE_INBOX": "Create Inbox"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "Ak chcete pridať svoj profil na Twitteri ako kanál, musíte overiť svoj profil Twitter kliknutím na \"Prihlásiť sa pomocou Twitteru\" ",
        "ERROR_MESSAGE": "Pri pripájaní k službe Twitter došlo k chybe, skúste to prosím znova",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Webový kanál",
        "DESC": "Vytvorte si kanál pre svoje webové stránky a začnite podporovať svojich zákazníkov prostredníctvom nášho webového widgetu.",
        "LOADING_MESSAGE": "Vytvorenie kanála webovej podpory",
        "CHANNEL_AVATAR": {
          "LABEL": "Logo kanálu"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Prosím zadajte platnú URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Webová doména",
          "PLACEHOLDER": "Zadajte doménu svojej webovej stránky (napr.: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Uvítací nadpis",
          "PLACEHOLDER": "Zdravím!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Uvítací slogan",
          "PLACEHOLDER": "Spojenie s nami je jednoduché. Spýtajte sa nás na čokoľvek alebo sa podeľte o svoju spätnú väzbu."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Uvítacia správa kanála",
          "PLACEHOLDER": "Acme zvyčajne odpovedá do niekoľkých hodín."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Povoliť pozdav v kanáli",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Zapnuté",
          "DISABLED": "Vypnuté"
        },
        "REPLY_TIME": {
          "TITLE": "Nastaviť čas odpovede",
          "IN_A_FEW_MINUTES": "O pár minút",
          "IN_A_FEW_HOURS": "O pár hodín",
          "IN_A_DAY": "O deň",
          "HELP_TEXT": "Tento čas odpovede sa zobrazí na widgete živého chatu"
        },
        "WIDGET_COLOR": {
          "LABEL": "Farba widgetu",
          "PLACEHOLDER": "Zmeniť farbu widgetu použitej vo widgete"
        },
        "SUBMIT_BUTTON": "Vytvoriť schránku",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Kanál Twilio SMS/WhatsApp",
        "DESC": "Integrujte Twilio a začnite podporovať svojich zákazníkov prostredníctvom SMS alebo WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID účtu",
          "PLACEHOLDER": "Zadajte prosím SID svojho účtu Twilio",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Toto pole je povinné"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "Toto pole je povinné",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Typ kanálu",
          "ERROR": "Prosím vyberte typ svojho kanálu"
        },
        "AUTH_TOKEN": {
          "LABEL": "Autentifikačný token",
          "PLACEHOLDER": "Zadajte svoj autentifikačný token pre Twilio",
          "ERROR": "Toto pole je povinné"
        },
        "CHANNEL_NAME": {
          "LABEL": "Meno schránky",
          "PLACEHOLDER": "Prosím vyplňte meno schránky",
          "ERROR": "Toto pole je povinné"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefónne číslo",
          "PLACEHOLDER": "Zadajte telefónne číslo, z ktorého bude správa odoslaná.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID účtu",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "Toto pole je povinné"
          },
          "API_KEY": {
            "LABEL": "API kľúč",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Toto pole je povinné"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Toto pole je povinné"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "Toto pole je povinné"
          },
          "INBOX_NAME": {
            "LABEL": "Meno schránky",
            "PLACEHOLDER": "Prosím vyplňte meno schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefónne číslo",
            "PLACEHOLDER": "Zadajte telefónne číslo, z ktorého bude správa odoslaná.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp kanál",
        "DESC": "Start supporting your customers via WhatsApp.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Meno schránky",
          "PLACEHOLDER": "Prosím vyplňte názov schránky",
          "ERROR": "Toto pole je povinné"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefónne číslo",
          "PLACEHOLDER": "Zadajte telefónne číslo, z ktorého bude správa odoslaná.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Phone number ID",
          "PLACEHOLDER": "Please enter the Phone number ID obtained from Facebook developer dashboard.",
          "ERROR": "Please enter a valid value."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Business Account ID",
          "PLACEHOLDER": "Please enter the Business Account ID obtained from Facebook developer dashboard.",
          "ERROR": "Please enter a valid value."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Verify Token",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Please enter a valid value."
        },
        "API_KEY": {
          "LABEL": "API kľúč",
          "SUBTITLE": "Configure the WhatsApp API key.",
          "PLACEHOLDER": "API kľúč",
          "ERROR": "Please enter a valid value."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "SUBMIT_BUTTON": "Create WhatsApp Channel",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Telefónne číslo",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "SID účtu",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Autentifikačný token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanál",
        "DESC": "Integrujte sa s kanálom API a začnite podporovať svojich zákazníkov.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Vytvoriť API kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa nám uložiť kanál API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Emailový kanál",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "E-mail, na ktorý vám zákazníci posielajú podporné tikety",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Vytvoriť e-mailový kanál",
        "API": {
          "ERROR_MESSAGE": "E-mailový kanál sa nám nepodarilo uložiť"
        },
        "FINISH_MESSAGE": "Začnite preposielať e-maily na túto e-mailovú adresu.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Kliknite sem",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanál",
        "DESC": "Integrujte sa s kanálom LINE a začnite podporovať svojich zákazníkov.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE kanál ID",
          "PLACEHOLDER": "LINE kanál ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE kanál Secret",
          "PLACEHOLDER": "LINE kanál Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE kanál Token",
          "PLACEHOLDER": "LINE kanál Token"
        },
        "SUBMIT_BUTTON": "Vytvorenie kanála LINE",
        "API": {
          "ERROR_MESSAGE": "Kanál LINE sa nepodarilo uložiť"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Musíte nakonfigurovať adresu URL webhooku v aplikácii LINE pomocou adresy URL uvedenej tu."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegramový kanál",
        "DESC": "Integrujte sa s kanálom Telegram a začnite podporovať svojich zákazníkov.",
        "BOT_TOKEN": {
          "LABEL": "Token pre bota",
          "SUBTITLE": "Nakonfigurujte token bota, ktorý ste získali od programu Telegram BotFather.",
          "PLACEHOLDER": "Token pre bota"
        },
        "SUBMIT_BUTTON": "Vytvoriť Telegram kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa uložiť Telegramový kanál"
        }
      },
      "AUTH": {
        "TITLE": "Vybrať kanál",
        "DESC": "Chatwoot supports live-chat widgets, Facebook Messenger, Twitter profiles, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "Email",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Tu môžete pridať agentov na správu novovytvorenej schránky. Len títo vybraní agenti budú mať prístup k vašej schránke. Agenti, ktorí nie sú súčasťou tejto schránky, nebudú môcť po prihlásení vidieť správy v tejto schránke ani na ne reagovať. <br> <b>PS:</b> Ak ako správca potrebujete prístup ku všetkým schránkam, mali by ste sa pridať ako agent ku všetkým vytvoreným schránkam.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Vyberte agentov pre schránku"
      },
      "DETAILS": {
        "TITLE": "Detaily schránky",
        "DESC": "Z rozbaľovacieho zoznamu nižšie vyberte stránku na Facebooku, ktorú chcete pripojiť k službe Chatwoot. Pre lepšiu identifikáciu môžete schránke zadať aj vlastný názov."
      },
      "FINISH": {
        "TITLE": "Podarilo sa!",
        "DESC": "Úspešne ste dokončili integráciu svojej stránky na Facebooku s Chatwoot. Pri ďalšej správe od zákazníka sa konverzácia automaticky zobrazí na vašej stránke.<br>Poskytujeme vám aj skript widgetu, ktorý môžete jednoducho pridať na svoju webovú stránku. Keď bude na vašej webovej stránke funkčný, zákazníci vám môžu posielať správy priamo z vašej webovej stránky bez pomoci akéhokoľvek externého nástroja a konverzácia sa objaví priamo tu, na Chatwoot.<br>Cool, čo? No, určite sa o to snažíme :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Spájame vás s Facebookom...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Niečo sa pokazilo, prosím, obnovte stránku...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Konfigurovať detaily schránky",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Pridať agentov",
      "ADD_AGENTS": "Pridávajú sa agenti do schránky..."
    },
    "FINISH": {
      "TITLE": "Vaša schránka je pripravená!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Reauthorize",
    "VIEW": "Zobraziť",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Úspešná aktualizácia nastavenia schránky",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "od",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Zapnúť"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Určite chcete vymazať ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Nastavenia",
      "COLLABORATORS": "Collaborators",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Otváracie hodiny",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Live"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Nastavenia",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agenti",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Vynucovanie overovania totožnosti používateľa",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "INBOX_IDENTIFIER": "Indetifikátor schránky",
      "INBOX_IDENTIFIER_SUB_TEXT": "Na overenie klientov API použite tu uvedený token `inbox_identifier`.",
      "FORWARD_EMAIL_TITLE": "Preposlanť na e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Začnite preposielať e-maily na túto e-mailovú adresu.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WHATSAPP_SECTION_SUBHEADER": "This API Key is used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "API kľúč",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Update API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Enter the new API Key here",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Update",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "Business Account ID",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "API kľúč",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Connect",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook Verification Token",
      "WHATSAPP_WEBHOOK_SUBHEADER": "This token is used to verify the authenticity of the webhook endpoint.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Zatvoriť",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Pridať",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Schránka",
          "PHONE_NUMBER": "Telefónne číslo",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Späť",
          "CANCEL": "Zrušiť",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings"
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "NONE": "Žiadne",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "ASSIGNMENT": {
      "TITLE": "Conversation Assignment",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Zrušiť",
      "CONFIRM_DELETE": "Vymazať",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Znova autorizovať",
      "SUBTITLE": "Vaše pripojenie k Facebooku vypršalo, pre pokračovanie v službách prosím znovu pripojte svoju stránku na Facebooku",
      "MESSAGE_SUCCESS": "Opätovné pripojenie bolo úspešné",
      "MESSAGE_ERROR": "Vyskytla sa chyba, skúste to prosím znova"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formuláre pred konverzáciou vám umožnia zachytiť informácie o používateľovi ešte predtým, ako s vami začne konverzovať.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Povinné"
      },
      "ENABLE": {
        "LABEL": "Povoliť formulár pred konverzáciou",
        "OPTIONS": {
          "ENABLED": "Áno",
          "DISABLED": "Nie"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Správa pred konverzáciou",
        "PLACEHOLDER": "Táto správa sa zobrazí používateľom spolu s formulárom"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Pred začatím chatu by mali návštevníci uviesť svoje meno a e-mailovú adresu"
      }
    },
    "CSAT": {
      "TITLE": "Enable CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Správa",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Language",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Go back"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "contains",
          "DOES_NOT_CONTAINS": "does not contain"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Nastavte svoju dostupnosť",
      "SUBTITLE": "Nastavenie dostupnosti na widgete livechatu",
      "WEEKLY_TITLE": "Nastaviť týždnový rozvrh",
      "TIMEZONE_LABEL": "Vybrať časové pásmo",
      "UPDATE": "Aktualizácia nastavení otváracích hodín",
      "TOGGLE_AVAILABILITY": "Povoliť nastavenie otváracích hodín pre túto schránku",
      "UNAVAILABLE_MESSAGE_LABEL": "Správa pre návštevníkov pri nedostupnosti",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "Day",
        "AVAILABILITY": "Dostupnosť",
        "HOURS": "Hours",
        "ENABLE": "Povolenie dostupnosti pre tento deň",
        "UNAVAILABLE": "Neodstupné",
        "VALIDATION_ERROR": "Začiatočný čas by mal byť pred zatváracím časom.",
        "CHOOSE": "Vybrať"
      },
      "ALL_DAY": "All-Day"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Nastaviť IMAP detaily",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Aktualizovať IMAP nastavenia",
      "TOGGLE_AVAILABILITY": "Povolenie konfigurácie IMAP pre túto schránku",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Úspešná aktualizácia nastavení IMAP",
        "ERROR_MESSAGE": "Nebolo možné aktualizovať nastavenia IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (napr. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prihlásenie",
        "PLACE_HOLDER": "Prihlásenie"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Heslo"
      },
      "ENABLE_SSL": "Povoliť SSL",
      "AUTH_MECHANISM": "Authentication"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Nastaviť SMTP detaily",
      "UPDATE": "Aktualizovať SMTP nastavenia",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prihlásenie",
        "PLACE_HOLDER": "Prihlásenie"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Doména",
        "PLACE_HOLDER": "Doména"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Uvítací nadpis",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Uvítací slogan",
          "PLACE_HOLDER": "Spojenie s nami je jednoduché. Spýtajte sa nás na čokoľvek alebo sa podeľte o svoju spätnú väzbu."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "O pár minút",
          "IN_A_FEW_HOURS": "O pár hodín",
          "IN_A_DAY": "O deň"
        },
        "WIDGET_COLOR_LABEL": "Farba widgetu",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Type:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Četujte s nami",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Četujte s nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Zvyčajne odpovedá do niekoľkých minút",
        "IN_A_FEW_HOURS": "Zvyčajne odpovedá do niekoľkých hodín",
        "IN_A_DAY": "Zvyčajne odpovedá do dňa"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Začať konverzáciu",
        "CHAT_INPUT_PLACEHOLDER": "Zadajte svoju správu"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "Momentálne nie sme k dispozícii"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Používame Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Other Providers",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanál",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
